export const disabledGuards = (checks) => {
    var _a;
    return (_a = checks.find((check) => check !== null)) !== null && _a !== void 0 ? _a : undefined;
};
